import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowDownIcon } from 'lucide-react';
const benefits = ['Organizar tus finanzas.', 'Detectar fugas de dinero.', 'Tomar mejores decisiones.', 'Planificar el crecimiento de tu negocio.', 'Aumentar tus ganancias.', 'Reducir el estrés financiero.'];
export function WhatIsIt() {
  return <section className="py-14 md:py-20 bg-background relative overflow-hidden" data-id="element-332">
      <div className="container mx-auto px-5 md:px-6" data-id="element-333">
        <div className="max-w-5xl mx-auto" data-id="element-334">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-16 items-center" data-id="element-335">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-336">
              <h2 className="text-2xl sm:text-3xl md:text-5xl mb-3 md:mb-6" data-id="element-337">
                ¿QUÉ ES{' '}
                <span className="text-primary italic" data-id="element-338">
                  REINICIA TUS FINANZAS?
                </span>
              </h2>
              <p className="text-base md:text-xl text-text-muted mb-5 md:mb-10 leading-relaxed" data-id="element-339">
                Reinicia Tus Finanzas es un sistema práctico y fácil de
                implementar diseñado para emprendedores, comerciantes y dueños
                de negocios que quieren recuperar el control de su dinero.
              </p>

              <div className="bg-surface rounded-2xl md:rounded-3xl p-5 md:p-8 border border-surface-light" data-id="element-340">
                <h3 className="font-sans font-semibold text-xs md:text-lg mb-4 md:mb-6 uppercase tracking-wider text-text-muted" data-id="element-341">
                  Aprenderás a:
                </h3>
                <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-2.5 md:gap-3 mb-5 md:mb-8" data-id="element-342">
                  {benefits.map((benefit, i) => <motion.li key={i} initial={{
                  opacity: 0,
                  y: 10
                }} whileInView={{
                  opacity: 1,
                  y: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: i * 0.08
                }} className="flex items-center gap-3" data-id="element-343">
                      <div className="w-5 h-5 md:w-6 md:h-6 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0" data-id="element-344">
                        <CheckIcon className="w-3 h-3 md:w-4 md:h-4 text-primary" data-id="element-345" />
                      </div>
                      <span className="text-sm md:text-lg" data-id="element-346">{benefit}</span>
                    </motion.li>)}
                </ul>
                <div className="pt-4 md:pt-6 border-t border-surface-light" data-id="element-347">
                  <p className="text-primary-light text-sm md:text-base font-medium flex items-start gap-2" data-id="element-348">
                    <span className="text-xl md:text-2xl leading-none" data-id="element-349">✨</span>
                    <span data-id="element-350">
                      Todo explicado paso a paso, incluso si nunca estudiaste
                      finanzas.
                    </span>
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Visual Motif — hidden on small mobile, shown md+ */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="hidden md:flex relative justify-center items-center h-full min-h-[400px]" data-id="element-351">
              <div className="absolute inset-0 bg-gradient-to-b from-red-500/5 via-transparent to-primary/10 rounded-[3rem] border border-surface-light" data-id="element-352" />

              <div className="relative flex flex-col items-center gap-8" data-id="element-353">
                <motion.div animate={{
                y: [0, -5, 0]
              }} transition={{
                duration: 4,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="w-32 h-32 rounded-2xl bg-surface border border-red-500/20 flex items-center justify-center shadow-lg relative" data-id="element-354">
                  <span className="text-4xl font-bold text-red-400 font-serif" data-id="element-355">
                    -$
                  </span>
                  <div className="absolute -inset-4 border border-red-500/10 rounded-3xl border-dashed animate-[spin_10s_linear_infinite]" data-id="element-356" />
                </motion.div>

                <div className="relative h-24 flex items-center justify-center" data-id="element-357">
                  <div className="absolute w-px h-full bg-gradient-to-b from-red-500/50 via-surface-light to-primary/50" data-id="element-358" />
                  <motion.div animate={{
                  y: [0, 20, 0]
                }} transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} className="relative z-10 bg-background p-2 rounded-full border border-surface-light" data-id="element-359">
                    <ArrowDownIcon className="w-6 h-6 text-text-muted" data-id="element-360" />
                  </motion.div>
                </div>

                <motion.div animate={{
                y: [0, 5, 0]
              }} transition={{
                duration: 4,
                repeat: Infinity,
                ease: 'easeInOut',
                delay: 1
              }} className="w-40 h-40 rounded-2xl bg-primary/10 border border-primary/30 flex items-center justify-center shadow-[0_0_40px_-10px_rgba(16,185,129,0.3)] relative" data-id="element-361">
                  <span className="text-5xl font-bold text-primary-light font-serif" data-id="element-362">
                    +$
                  </span>
                  <div className="absolute -inset-4 border border-primary/20 rounded-3xl animate-[spin_15s_linear_infinite_reverse]" data-id="element-363" />
                  <div className="absolute -inset-8 border border-primary/10 rounded-[2.5rem] border-dashed animate-[spin_20s_linear_infinite]" data-id="element-364" />
                </motion.div>
              </div>
            </motion.div>

            {/* Mobile-only compact motif: horizontal -$ → +$ */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="flex md:hidden items-center justify-center gap-4 py-4" data-id="element-365">
              <div className="w-20 h-20 rounded-2xl bg-surface border border-red-500/20 flex items-center justify-center" data-id="element-366">
                <span className="text-2xl font-bold text-red-400 font-serif" data-id="element-367">
                  -$
                </span>
              </div>
              <div className="flex-1 h-px bg-gradient-to-r from-red-500/40 via-text-muted/30 to-primary/40 relative" data-id="element-368">
                <motion.div animate={{
                x: [0, 20, 0]
              }} transition={{
                duration: 2,
                repeat: Infinity,
                ease: 'easeInOut'
              }} className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 w-7 h-7 rounded-full bg-background border border-surface-light flex items-center justify-center" data-id="element-369">
                  <ArrowDownIcon className="w-4 h-4 text-text-muted -rotate-90" data-id="element-370" />
                </motion.div>
              </div>
              <div className="w-24 h-24 rounded-2xl bg-primary/10 border border-primary/30 flex items-center justify-center shadow-[0_0_25px_-8px_rgba(16,185,129,0.4)]" data-id="element-371">
                <span className="text-3xl font-bold text-primary-light font-serif" data-id="element-372">
                  +$
                </span>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}